/* eslint-disable */
import React, {
    Component
} from 'react';
import {
    showErrorNotification
} from '../../notifications';
import {
    addDonorurl
} from '../actions';


type Props = {

	/**
	 * Invoked to obtain translated strings.
	 */
	t: Function,

	/**
	 * The URL of the Donorbox.
	 */
	_addUrldialog: Function,

	/**
	 * Dispatches a error notificatio
	 */
	_addErrorNotification: Function

};

export default class AbstractdonorboxDialog extends Component <Props> {
    /**
	 * Instantiates a new component.
	 *
	 *
	 * @inheritdoc
	 */
    constructor(props: Props) {
        super(props);
        this.state = {
            textc: null,
            url: false
        };
        this._onSubmitWeb = this._onSubmitWeb.bind(this);
        this._onSubmitNative = this._onSubmitNative.bind(this);
        this._urlExists = this._urlExists.bind(this);
    }


	_urlExists: () => string;

	/**
	 * Url Await.
	 *
	 * @param {string} value - The url value.
	 * @returns {boolean} The url of the donorbox.
	 */
	_urlExists = async (urll: string) => {

        const data = await fetch(urll, { method: 'head', mode: 'no-cors' });

	    return data.status;
	};

	_onSubmitWeb: string => boolean;

	/**
	 * Submit the Form.
	 *
	 * @param {string} value - The url value.
	 * @returns {boolean} The url of the donorbox.
	 */
	 _onSubmitWeb = async urll => {
	     const url12 = this.state.textc;
	     const p = /^(?:https?:\/\/)?(?:www\.)?(?:|donorbox\.org\/((\w|-))(?:\S+))?$/; // eslint-disable-line max-len
	     const url1 = `${url12}?modal=true`;

	     const urltrue = await this._urlExists(url1);

	    //  console.log('working',urltrue);
	     if (!this.state.textc.match(p)) {
	         this.setState({
	             url: true
	         });
	         this.props._addErrorNotification({
	             descriptionKey: 'donorbox.errorDesc',
	             titleKey: 'donorbox.errorNotification'
	         }, 5000);

	         return false;
	     }

	     if (urltrue === 404) {
	         this.setState({
	             url: true
	         });
	         this.props._addErrorNotification({
	             descriptionKey: 'donorbox.errorDesc',
	             titleKey: 'donorbox.errorNotification'
	         }, 5000);

	         return false;
	     }
	    //  console.log(url12);
	     this.props._addUrldialog(url12);

	     return true;
	 }

     _onSubmitNative: string => boolean;

    /**
	 * Submit the Form.
	 *
	 * @param {string} value - The url value.
	 * @returns {boolean} The url of the donorbox.
	 */
	 _onSubmitNative = async urll => {

	     const p = /^(?:https?:\/\/)?(?:www\.)?(?:|donorbox\.org\/((\w|-))(?:\S+))?$/; // eslint-disable-line max-len
	     const url1 = `${urll}?modal=true`;

	     const urltrue = await this._urlExists(url1);

	     if (!urll.match(p)) {
	         this.setState({
	             url: true
	         });
	         this.props._addErrorNotification({
	             descriptionKey: 'donorbox.errorDesc',
	             titleKey: 'donorbox.errorNotification'
	         }, 5000);

	         return false;
	     }

	     if (urltrue === 404) {
	         this.setState({
	             url: true
	         });
	         this.props._addErrorNotification({
	             descriptionKey: 'donorbox.errorDesc',
	             titleKey: 'donorbox.errorNotification'
	         }, 5000);

	         return false;
	     }
	     this.props._addUrldialog(urll);

	     return true;
	 }


}


/**
 * Redux _mapDispatchToProps .
 *
 * @param {number} dispatch - The Function.
 * @returns  {string} For the donorbox url.
 */
export function mapDispatchToProps(dispatch: Function): Object {

    return {
        _addUrldialog(url: string) {
            dispatch(addDonorurl(url));
        },
        _addErrorNotification(desc: Object) {
            dispatch(showErrorNotification(desc));
        }

    };
}
